<template>
<section>
    <h1 class="main-title latest-title grid-container">Latest</h1>
    <div class="mobile-navigation latest layer3"></div>
    
    <div class="social-latest grid-100 grid-parent layer1">
        <div class="grid-container">
            <div class="grid-50">
                <div class="fb-box odd layer1">
                    <a target="_blank" href="https://www.facebook.com/Ross.Noble/" class="layer1">
                        <h4>Ross.Noble</h4>
                    </a>
                    <p v-html="fbPosts[0].message" class="fb-post-paragraph"></p>
                    <span class="date">{{fbPosts[0].date}}</span>
                    <div class="social-icon"> <a target="_blank" href="https://www.facebook.com/Ross.Noble/"><img src='../../assets/images/facebook_white.png' /></a></div>
                </div>
                <div class="tw-box even grid-48" v-if="twPosts[0]">
                    <a target="_blank"
                        v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[0].id_str"><h4>
                        @Realrossnoble</h4></a>
                    <p v-html="twPosts[0].text"></p>
                    <span class="date">{{$parent.getDateInFormatTW(twPosts[0].created_at)}}</span>
                    <div class="social-icon"> <a v-if="twPosts[0]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[0].id_str"><img src='../../assets/images/twitter.png'/></a></div>
                </div>
                <div class="tw-box odd grid-48 margin-left-4" v-if="twPosts[1]">
                    <a target="_blank"
                        v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[1].id_str"><h4>
                        @Realrossnoble</h4></a>
                    <p v-html="twPosts[1].text"></p>
                    <span class="date">{{$parent.getDateInFormatTW(twPosts[1].created_at)}}</span>
                    <div class="social-icon"> <a v-if="twPosts[1]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[1].id_str"><img src='../../assets/images/twitter_white.png'/></a></div>
                </div>
                <div class="fb-box even">
                    <a target="_blank" href="https://www.facebook.com/Ross.Noble/" class="layer1">
                        <h4>Ross.Noble</h4>
                    </a>
                    <p v-html="fbPosts[2].message" class="fb-post-paragraph"></p>
                    <span class="date">{{fbPosts[1].date}}</span>
                    <div class="social-icon"> <a target="_blank" href="https://www.facebook.com/Ross.Noble/"><img src='../../assets/images/facebook.png'/></a></div>
                </div>
                <div class="home-cta grid-100 grid-parent layer1">
                    <a href="#/latest" class="layer1">
                        <span>More</span>
                        <img src="../../assets/images/arrow_home_cta.png"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
    name: "Latest",
    props: {
        fbPosts: {
            type: Array,
            required: true,
        },
        twPosts: {
            type: Array,
            required: true,
        },
    },
};
</script>


// WEBPACK FOOTER //
// Latest.vue?588093cb